import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: '#ffffff',
        border: '1px solid #E4E7EC',
        borderRadius: 8,
        padding: '44px 48px',
    },
    headingRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 16,
        marginBottom: 8,
    },
    heading: {
        letterSpacing: '-0.01em',
    },
    statusBadge: ({ isPublic }) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 13px',
        borderRadius: 20,
        fontSize: 12.5,
        fontWeight: 600,
        letterSpacing: '.02em',
        backgroundColor: isPublic ? '#E7F6EC' : '#F2F4F7',
        color: isPublic ? '#0A6B33' : theme.palette.text.secondary,
    }),
    statusDot: ({ isPublic }) => ({
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: isPublic ? '#12B76A' : '#98A2B3',
    }),
    description: {
        color: theme.palette.text.secondary,
        marginBottom: 34,
        maxWidth: '90ch',
    },
    toggleCard: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 24,
        border: '1px solid #E4E7EC',
        borderRadius: 8,
        padding: '24px 26px',
        marginBottom: 30,
    },
    toggleTitle: {
        fontWeight: 600,
        marginBottom: 6,
    },
    toggleDescription: {
        color: theme.palette.text.secondary,
    },
    saveFlash: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginTop: 20,
        color: '#0A6B33',
        fontWeight: 600,
        fontSize: 13.5,
        opacity: 0,
        transition: 'opacity .25s ease',
    },
    saveFlashVisible: {
        opacity: 1,
    },
}));
